import React, { PureComponent, Fragment } from 'react';
import { object } from 'prop-types';
import { Container, Header } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

import {
  AssetDownloadsTable,
  Wrappers,
  PageHeader,
  Loader
} from '../components';
import { withPageViewTracking, withAnalytics } from '../analytics';
import { logoAPIs } from '../api';
import { withAuth, AuthRoles } from '../auth';
import { BrandHelper } from '../utils';

const {
  swapImageEndpointForDownload,
  mapNameIfParentNull
} = AssetDownloadsTable.helpers;

class Logos extends PureComponent {
  state = {
    allLogos: null,
    brands: null,
    logos: null,
    searchFilter: null,
    selectedBrand: null
  };

  static propTypes = {};

  async componentDidMount() {
    let brands, logos;
    const { authUser } = this.props;

    const isAGIUser = AuthRoles.isAGIUser(authUser, 'roles');

    const authBrands = BrandHelper.filterAuthorizedBrands(
      authUser.brands,
      isAGIUser
    );
    try {
      const allBrands = await logoAPIs.brands();
      brands = BrandHelper.filterAllBrandByAuthBrands(allBrands, authBrands);
      logos = await logoAPIs.search({});
    } catch (error) {
      if (!brands) {
        brands = { error: error.toString() };
      }
      if (!logos) {
        logos = { error: error.toString() };
      }
    }

    if (Array.isArray(logos)) {
      logos = logos
        .map(logo => {
          const { ProductBrand, FileLink } = logo;
          // ensure expected attributes
          return {
            ...logo,
            ProductBrand: mapNameIfParentNull(ProductBrand),
            FileLink: swapImageEndpointForDownload(FileLink)
          };
        })
        .filter(
          logo =>
            // filter brands that are authorized for the user
            // no ability to pass certain brand params to api query
            isAGIUser ||
            brands.find(brand => brand.Name === logo.ProductBrand.Name)
        );
    }
    this.setState({
      brands,
      logos,
      allLogos: logos
    });
  }

  // used only for on Brand change now
  filterLogos = () => {
    const { allLogos, selectedBrand } = this.state;
    let logos = allLogos;
    // if brand filter has been selected; filter alllogos
    if (selectedBrand && selectedBrand !== '') {
      logos = allLogos
        .filter(logo => {
          return logo.ProductBrand != null;
        })
        .filter(logo => logo.ProductBrand.Name === selectedBrand);
    }
    this.setState({ logos });
  };

  handleBrandChange = selectedBrand => {
    this.setState({ selectedBrand }, () => {
      this.filterLogos();
    });
  };

  handleSearchInput = e => {
    const searchFilter = e.target.value.toLowerCase();
    this.setState({ searchFilter });
  };

  render() {
    const { brands, logos, allLogos, selectedBrand, searchFilter } = this.state;
    const isLoading = !brands || !logos || (brands && brands.error);

    return (
      <Wrappers.Layout menu>
        <Container as="main">
          {isLoading ? (
            <Loader active />
          ) : (
            <Fragment>
              <PageHeader overlap>
                <Header as="h1" data-qa="brochure-page-header">
                  <small>Marketing</small>
                  <FormattedMessage
                    id="title.logos"
                    description="Logo Title"
                    defaultMessage="Logos"
                  />
                </Header>
              </PageHeader>

              <AssetDownloadsTable.FilterBar
                handleBrandChange={this.handleBrandChange}
                selectedBrand={selectedBrand ? selectedBrand : ''}
                brands={brands}
                handleSearchInput={this.handleSearchInput}
              />

              <AssetDownloadsTable.Body
                data={logos}
                total={allLogos && allLogos.length}
                searchFilter={searchFilter}
                assetType="logo"
                columns={[
                  {
                    Header: 'Brand',
                    accessor: 'ProductBrand.Name',
                    sortType: 'basic'
                  },
                  {
                    Header: 'Placement',
                    accessor: 'Placement',
                    sortType: 'basic'
                  },
                  {
                    Header: 'Format',
                    accessor: 'Format',
                    sortType: 'basic',
                    Cell: AssetDownloadsTable.Cells.Format
                  },
                  {
                    Header: 'File name',
                    accessor: 'FileName',
                    sortType: 'basic',
                    Cell: AssetDownloadsTable.Cells.FileName
                  },

                  {
                    Header: '',
                    accessor: 'FileLink',
                    Cell: AssetDownloadsTable.Cells.Download,
                    disableSortBy: true,
                    isCTA: true
                  }
                ]}
              />
            </Fragment>
          )}
        </Container>
      </Wrappers.Layout>
    );
  }
}

Logos.propTypes = {
  authUser: object.isRequired
};

export default withPageViewTracking({ eventName: 'Logos Page Visit' })(
  withAnalytics(withAuth(Logos))
);
